import React from 'react'

function TenderTextCeiling() {
  return (
    <embed src="\pdfs\EAT1.4.6_Q-DN_Q-DV_Ceiling_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextCeiling